import { render, staticRenderFns } from "./AutobuyerGroupToggleLabel.vue?vue&type=template&id=083b4b97&scoped=true"
import script from "./AutobuyerGroupToggleLabel.vue?vue&type=script&lang=js"
export * from "./AutobuyerGroupToggleLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b4b97",
  null
  
)

export default component.exports